<template>
  <a-card :bordered="false" class="profit-distribution">
    <!-- Query area -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="16" class="search-row">
          <a-col :md="5" :sm="8">
            <a-form-item :label="$t('date')">
              <a-range-picker
                v-model="queryParam.dateRange"
                format="DD-MM-YYYY"
                valueFormat="YYYY-MM-DD"
                style="width: 100%"
                :placeholder="[$t('startTime'), $t('endTime')]"
                @change="onDateChange"
              />
            </a-form-item>
          </a-col>
          <a-col :md="5" :sm="8">
            <a-form-item :label="$t('investorList.hkddh')">
              <a-input v-model="queryParam.repayOrderId" :placeholder="$t('enter')" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="5" :sm="8">
            <a-form-item :label="$t('investorList.zcbid')">
              <a-input v-model="queryParam.investId" :placeholder="$t('enter')" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="5" :sm="8">
            <a-form-item>
              <a-input-group compact>
                <a-select v-model="queryParam.searchType" style="width: 120px">
                  <a-select-option value="repayUserName">{{ $t('investorList.hkrxm') }}</a-select-option>
                  <a-select-option value="repayUserMobile">{{ $t('investorList.hkrsjh') }}</a-select-option>
                </a-select>
                <a-input v-model="queryParam.keyword" style="width: 150px" :placeholder="$t('enter')" allow-clear />
              </a-input-group>
            </a-form-item>
          </a-col>
          <a-col :md="4" :sm="8">
            <a-form-item>
              <a-button style="margin-right: 10px" type="primary" @click="handleSearch">{{ $t('search') }}</a-button>
              <a-button style="margin-right: 10px" @click="handleReset">{{ $t('reset') }}</a-button>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- Toolbar -->
    <!-- <div class="toolbar">
     
    </div> -->

    <!-- Table area -->
    <a-table
      bordered
      :columns="columns"
      :dataSource="dataSource"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
      rowKey="repayOrderId"
    >
      <span slot="repayAmount" slot-scope="text">
        {{ text | FenToDong }}
      </span>
      <span slot="action" slot-scope="text, record">
        <a @click="handleViewDetail(record)">{{ $t('investorList.zjfpmx') }}</a>
      </span>
    </a-table>
    <earnings-details-modal ref="earningsDetailsModal" />
  </a-card>
</template>

<script>
import { getIncomeDistributionList, exportIncomeDistributionList } from '@/webpublicapi/vietnamBackstage'
import EarningsDetailsModal from './modules/EarningsDetailsModal.vue'
import { exportFile } from '@/webpublicapi/exportFile'
import moment from 'moment'

export default {
  name: 'ProfitDistribution',
  components: {
    EarningsDetailsModal,
  },
  data() {
    return {
      queryParam: {
        dateRange: [],
        begin: '',
        end: '',
        repayOrderId: '',
        investId: '',
        searchType: 'repayUserName',
        keyword: '',
      },
      dataSource: [],
      loading: false,
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        showTotal: (total) => `${this.$t('components.total')} ${total} ${this.$t('components.items')}`,
      },
    }
  },
  computed: {
    columns() {
      return [
        { title: this.$t('date'), dataIndex: 'repayDate', align: 'center' },
        { title: this.$t('investorList.hkrxm'), dataIndex: 'custName', align: 'center' },
        { title: this.$t('investorList.hkrsjh'), dataIndex: 'mobileNo', align: 'center' },
        { title: this.$t('investorList.hkddh'), dataIndex: 'repayOrderId', align: 'center' },
        { title: this.$t('investorList.zcbid'), dataIndex: 'investId', align: 'center' },
        {
          title: this.$t('investorList.hkje'),
          dataIndex: 'repayAmount',
          align: 'center',
          scopedSlots: { customRender: 'repayAmount' },
        },
        {
          title: this.$t('investorList.cz'),
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' },
        },
      ]
    },
  },
  created() {
    const todayStart = moment().startOf('day')
    const todayEnd = moment().endOf('day')
    this.queryParam.dateRange = [todayStart, todayEnd]
    this.queryParam.begin = todayStart.format('YYYY-MM-DD')
    this.queryParam.end = todayEnd.format('YYYY-MM-DD')
    this.loadData()
  },
  methods: {
    onDateChange(dates, dateStrings) {
      if (!dates || dates.length === 0) {
        this.queryParam.begin = ''
        this.queryParam.end = ''
        return
      }
      this.queryParam.begin = this.queryParam.dateRange[0]
      this.queryParam.end = this.queryParam.dateRange[1]
    },
    handleReset() {
      const todayStart = moment().startOf('day')
      const todayEnd = moment().endOf('day')
      this.queryParam = {
        dateRange: [todayStart, todayEnd],
        begin: todayStart.format('YYYY-MM-DD'),
        end: todayEnd.format('YYYY-MM-DD'),
        repayOrderId: '',
        investId: '',
        searchType: 'repayUserName',
        keyword: '',
      }
      this.pagination.current = 1
      this.loadData()
    },
    handleSearch() {
      this.pagination.current = 1
      this.loadData()
    },
    handleTableChange(pagination) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.loadData()
    },
    buildParams() {
      const rawParams = {
        pageNo: this.pagination.current,
        pageSize: this.pagination.pageSize,
        begin: this.queryParam.begin ? `${this.queryParam.begin} 00:00:00` : '',
        end: this.queryParam.end ? `${this.queryParam.end} 23:59:59` : '',
        repayOrderId: this.queryParam.repayOrderId,
        investId: this.queryParam.investId,
      }

      const keyword = (this.queryParam.keyword || '').trim()
      if (keyword) {
        rawParams[this.queryParam.searchType] = keyword
      }

      return Object.keys(rawParams).reduce((acc, key) => {
        const value = rawParams[key]
        if (value !== '' && value !== undefined && value !== null) {
          acc[key] = value
        }
        return acc
      }, {})
    },
    loadData() {
      this.loading = true
      getIncomeDistributionList(this.buildParams())
        .then((res) => {
          if (res.success || res.respCode === 1000 || res.code === 200) {
            const data = res.respData || res.result || {}
            if (data.records.length > 0) {
              data.records.forEach((item) => {
                if (item.repayDate) {
                  item.repayDate = this.transformTime(item.repayDate, 2)
                }
              })
            }
            this.dataSource = data.records || []
            this.pagination.total = data.total || 0
          } else {
            this.$message.warning(res.respMsg || res.message || this.$t('platformCollection.query_failed'))
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleExport() {
      // Export API only needs begin-end-repayOrderId-investId-repayUserName-repayUserMobile These params
      const params = {
        begin: this.queryParam.begin ? `${this.queryParam.begin} 00:00:00` : '',
        end: this.queryParam.end ? `${this.queryParam.end} 23:59:59` : '',
        repayOrderId: this.queryParam.repayOrderId,
        investId: this.queryParam.investId,
      }

      // From dropdown+Input combination of payer names/Phone number
      const keyword = (this.queryParam.keyword || '').trim()
      if (keyword) {
        if (this.queryParam.searchType === 'repayUserName') {
          params.repayUserName = keyword
        } else if (this.queryParam.searchType === 'repayUserMobile') {
          params.repayUserMobile = keyword
        }
      }

      // Filter null values
      const exportParams = Object.keys(params).reduce((acc, key) => {
        const value = params[key]
        if (value !== '' && value !== undefined && value !== null) {
          acc[key] = value
        }
        return acc
      }, {})

      this.loading = true
      exportIncomeDistributionList(exportParams)
        .then((res) => {
          // Returned by backend res Could be:
          // 1. Blob Object (if responseType: 'blob')
          // 2. { fileName, data } Object (if set downloadFile)
          // 3. { data: Blob, ... } Object
          let blob = null
          let fileName = `${this.$t('platformCollection.profit_distribution_record')}_${moment().format(
            'YYYYMMDDHHmmss'
          )}.xlsx`

          if (res instanceof Blob) {
            blob = res
          } else if (res && res.data instanceof Blob) {
            blob = res.data
            if (res.fileName) {
              fileName = decodeURIComponent(res.fileName)
            }
          } else if (res && res.data) {
            // Compatible with other formats
            blob = res.data
          }

          if (blob) {
            exportFile(blob, fileName)
            this.$message.success(this.$t('platformCollection.export_success'))
          } else {
            this.$message.warning(this.$t('platformCollection.export_failed_format_error'))
          }
        })
        .catch((err) => {
          console.error('Export failed:', err)
          this.$message.error(this.$t('platformCollection.export_failed_retry'))
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleViewDetail(record) {
      // Fund allocation details: will integrate specific modal or route when needed
      this.$refs.earningsDetailsModal.show(record)
    },
  },
}
</script>

<style lang="less" scoped>
@import '~@/assets/less/common.less';

.profit-distribution {
  .table-page-search-wrapper {
    margin-bottom: 12px;
  }

  .search-actions {
    display: flex;
    justify-content: center;
    gap: 8px;
    margin: 8px 0 16px;
  }

  .toolbar {
    margin-bottom: 16px;
  }
}
</style>
